<template>
  <div id="app">
    <v-app :dark="env === 'development'">
      <component :is="layout">
        <router-view />
        <footer style="margin-top: 80px;"></footer>
      </component>
    </v-app>
  </div>
</template>

<script>
import DefaultLayout from "./views/layouts/Default";
import EmptyWithNavbarLayout from "./views/layouts/EmptyWithNavbar";
import EmptyLayout from "./views/layouts/Empty";
import AnonLayout from "./views/layouts/Anon";

export default {
  components: { DefaultLayout, EmptyLayout, EmptyWithNavbarLayout, AnonLayout },
  computed: {
    env() {
      return process?.env?.NODE_ENV;
    },
    layout() {
      return (this.$route.meta.layout || "default") + "-layout";
    }
  }
};
</script>
